<template>
  <div id="Roaming">
    <div>
      <div class="social-nav filter-blur-50 border-bottom-white-1-50">
        <div style="width: 100vw" class="tabsContainer tabAlign">
          <v-tabs v-model="tab" grow centered show-arrows class="social-tab">
            <v-tabs-slider color="#FFCB05"></v-tabs-slider>
            <v-tab v-for="(item, i) in info.items" :key="item.title">
              <span
                :class="[(lang === 'ar' && i !== tab ? 'regular-ar' : i !== tab ? 'regular-en' : lang === 'ar' && i === tab ? 'bold-italic-ar' : 'bold-italic-en')]">{{
                  item.title }}</span>
            </v-tab>
          </v-tabs>
        </div>
      </div>
      <v-tabs-items v-model="tab" :touchless="true">
        <div class="products-container" style="padding-top: 160px">
          <v-tab-item v-for="item in info.items" :key="item.title">
            <component :is="item.comp" :data="item.cardContent" :error="error" :load="load" :info="item.test" />
          </v-tab-item>
        </div>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import Navbar from '../Navbar'
import internationalRoaming from './internationalRoaming'
import roamingService from './roamingService'
import RoamingRepository from '../../repositories/RoamingRepository'
export default {
  name: 'index',
  components: { Navbar, internationalRoaming, roamingService },
  data () {
    return {
      Roaming: new RoamingRepository(),
      tab: null,
      info:
      {
        title: this.$t('products.title'),
        items:
          [{
            title: this.$t('roamingService.international'),
            cardContent: '',
            comp: 'internationalRoaming',
            path: 'international-roaming',
            test: []
          },
          {
            title: this.$t('roamingService.SMS'),
            cardContent: '',
            comp: 'roamingService',
            path: 'roaming-service',
            test: []
          }]
      },
      activeTab: '',
      lang: this.$lang,
      load: false,
      error: false
    }
  },
  created () {
    this.activeTab = this.$route.params.id
    this.$store.state.activeSectionNav = null
  },
  mounted () {
    this.getData()
    this.arabic()
    // this.tab = utils.checkActiveTab(this.info.items, this.activeTab)
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        $('.social-nav').css('direction', 'rtl')
        $('.arrowIcon').css('transform', 'rotateY(180deg)')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.social-tab .v-tab').css('transform', 'rotateY(180deg)')
        $('.social-tab .v-tab').css('padding', '0 3vw')
      }
    },
    async getData () {
      this.load = true
      try {
        const response = await this.Roaming.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.serviceFeatures.length; i++) {
            this.info.items[i].cardContent = response.data.serviceFeatures[i].html
            // this.info.items[i].test = response.data.serviceFeatures[i].featureInfos
            for (let j = 0; j < response.data.serviceFeatures[i].featureInfos.length; j++) {
              this.info.items[i].test.push(response.data.serviceFeatures[i].featureInfos[j].text)
            }
          }
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
        console.log(e)
      }
      this.load = false
    }
  },
  watch: {
    tab (val) {
      window.scrollTo(0, 0)
      this.$store.state.tab = val
      $('#press_releases .tabsContainer').addClass('arabicTabContainer')
      $('#press_releases .innerTabContainer .v-tab').css('transform', 'rotateY(180deg)')
    }
    // '$route.params.id': {
    // handler: function (id) {
    //   this.tab = utils.checkActiveTab(this.info.items, id)
    // },
    // deep: true,
    // immediate: true
    // }
  }
}
</script>

<style lang="scss">
@import "src/assets/sass/main";

#Roaming {
  .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
    color: rgba(29, 29, 29, 0.6) !important;
  }

  .tabsContainer {
    height: 50px;
  }

  .social-tab .v-tab--active {
    color: $--yellow !important;
  }

  .social-tab .v-tab--active {
    color: $--yellow !important;
    font-family: Mtn-bold;
    font-size: 12px;
  }

  .social-nav {
    height: 50px;
    background: rgba(242, 242, 242, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }

  .social-tab .v-tab {
    text-transform: capitalize;
  }

  //.v-item-group.theme--light.v-slide-group.v-tabs-bar.v-tabs-bar--is-mobile.v-tabs-bar--show-arrows.primary--text{
  //  width: 80%;
  //}
  .social-nav .v-tabs,
  .v-tabs-bar {
    height: 100%;
  }

  .theme--light.v-tabs>.v-tabs-bar {
    background: transparent !important;
  }

  .social-nav .v-tabs {
    display: flex;
    justify-content: space-around !important;
    align-items: center !important;
  }

  .social-tab .v-tab {
    padding: 0 2vw;
    font-size: 15px;
    width: 50vw;
  }

  @media only screen and (min-width: 600px) {

    .social-tab .v-slide-group__next,
    .v-slide-group__prev {
      display: none !important;
    }
  }

  @media only screen and (max-width: 650px) {
    .tabsContainer {
      width: 100vw !important;
    }

    .tabAlign {
      padding: 0 4vw;
    }
  }

  .arabicTabContainer {
    direction: ltr;
    transform: rotateY(180deg);
  }
}
</style>
<style scoped>
.products-container {
  min-height: 100vh;
}
</style>
